import queryString from "query-string";
import {
  PROJECT_USER_ID,
  TEAM_IDS,
  USER_IDS
} from "../../../../constants/filters";
import { GetIdsList } from "../../../../assets/convertUrlFilter";
import { getTeamIdForGivenProjectUser } from "../../../../assets/getTeamIds";

export const GetReportFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  const getTeamIdFromProjectUserId = !filters[TEAM_IDS] && filters[PROJECT_USER_ID]
    ? [getTeamIdForGivenProjectUser()]
    : undefined;
  return {
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: filters[TEAM_IDS]
      ? GetIdsList(filters[TEAM_IDS])
      : getTeamIdFromProjectUserId
  };
};
